import React from "react";
import { IconProps } from "../icon";

export const ParagraphWrapIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 6h18M3 12h15a3 3 0 010 6h-4m0 0l2-2m-2 2l2 2M3 18h7"
    />
  </svg>
);
